import axios from 'services/axios';
import { GetInstancesByProductParams } from '../types';
import { getInstancesByProductQuery } from './queries/getInstancesByProductQuery';

const VITE_APP_API_URL = import.meta.env.VITE_APP_API_URL;

type GetInstancesResponse = {
  data: { data: { products: { [x: string]: any } } };
  error_type: any;
};

export const getInstancesByProductId = async ({
  org_id,
  product_id,
  since,
  before,
  limit,
  operation_type,
}: GetInstancesByProductParams): Promise<GetInstancesResponse['data']['data']['products']> => {
  try {
    const response: { data: GetInstancesResponse['data'] } = await axios.post(
      `${VITE_APP_API_URL}/opensearch/v3/graphql/`,
      {
        query: getInstancesByProductQuery,
        variables: { org_id, since, before, limit, product_id, operation_type },
      },
    );
    return response.data.data.products[0];
  } catch (err: any) {
    return err;
  }
};
